export default {
  /**
   * Trạng thái của form
   */
  FormState: {
    Add: "Thêm",
    View: "Xem",
    Edit: "Sửa",
    Duplicate: "Nhân bản",
    QuickAdd: "Thêm nhanh"
  },
  /**
   * Giới tính
   */
  Gender: {
    Female: "Nữ",
    Male: "Nam",
    Other: "Khác"
  },
  /**
   * toán tử filter
   */
  FilterHeader: {
    Contains: "Chứa",
    Notcontains: "Không chứa",
    StartsWith: "Bắt đầu với",
    EndsWith: "Kết thúc với",
    Null: "(Trống)",
    NotNull: "(Không trống)",
    Equals: "Bằng",
    NotEquals: "Khác",
    GreaterThan: "Lớn hơn",
    GreaterThanEquals: "Lớn hơn hoặc bằng",
    LessThan: "Nhỏ hơn",
    LessThanEquals: "Nhỏ hơn hoặc bằng",
    Between: "Trong khoảng"
  },

  OrganizationUnitType: {
    Corporations: "Tổng công ty",
    Group: "Tập đoàn",
    Subsidiaries: "Công ty con",
    Branch: "Chi nhánh",
    Representative: "Văn phòng đại điện",
    Office: "Văn phòng",
    Center: "Trung tâm",
    Department: "Phòng ban",
    Team: "NHóm/tổ/đội",
    Factory: "Phân xưởng"
  },
  EngineCode: {
    M: "Level 1M",
    O: "Level 2O",
    Z: "Level 3Z",
    N: "Level 4N"
  },
  EmployeeType: {
    Probation: "Thử việc",
    Office: "Chính thức",
    Manage: "Quản lý",
  },
  Period: {
    ThisDay: "Hôm nay",
    ThisWeek: "Tuần này",
    FirstWeekToPresent: "Đầu tuần tới hiện tại",
    ThisMonth: "Tháng này",
    FirstMonthToPresent: "Đầu tháng tới hiện tại",
    ThisQuarter: "Quý này",
    FirstQuarterToPresent: "Đầu quý tới hiện tại",
    ThisYear: "Năm nay",
    FirstYearToPresent: "Đầu năm tới hiện tại",
    SixFirstMonth: "Sáu tháng đầu năm",
    SixLastMonth: "Sáu tháng cuối năm",
    January: "Tháng 1",
    February: "Tháng 2",
    March: "Tháng 3",
    April: "Tháng 4",
    May: "Tháng 5",
    June: "Tháng 6",
    July: "Tháng 7",
    August: "Tháng 8",
    September: "Tháng 9",
    October: "Tháng 10",
    November: "Tháng 11",
    December: "Tháng 12",
    FiscalI: "Quý 1",
    FiscalII: "Quý 2",
    FiscalIII: "Quý 3",
    FiscalIV: "Quý 4",
    Yesterday: "Hôm qua",
    LastWeek: "Tuần trước",
    LastMonth: "Tháng trước",
    LastQuarter: "Quý trước",
    LastYear: "Năm trước",
    Tomorrow: "Ngày mai",
    NextWeek: "Tuần sau",
    NextMonth: "Tháng sau",
    NextQuarter: "Quý sau",
    NextYear: "Năm sau",
    Custom: "Tùy chọn",
  },
  ProfileStatus: {
    Pending: 'Chờ thực hiện',
    Processing: 'Đang thực hiện',
    Completed: 'Hoàn thành',
    Canceled: 'Đã hủy bỏ'
  },
  ScanStatus: {
    Pending: 'Chờ thực hiện',
    Processing: 'Đang thực hiện',
    Completed: 'Hoàn thành'
  },
  Severity: {
    Low: 'Thấp',
    Medium: 'Trung bình',
    High: 'Nghiêm trọng',
    Critical: 'Nguy hiểm',
  },
  ScanLevel: {
    Wide: 'Quét diện rộng',
    Deep: 'Quét chuyên sâu',
  },
  ScanType: {
    Device: 'Thiết bị',
    Website: 'Website',
  },
  ScanEngine: {
    E1: "Level 1",
    E2: "Level 2",
    E3: "Level 3",
    E4: "Level 4",
  },
  UserLogAction: {
    Create: 'Thêm',
    Update: 'Sửa',
    Delete: 'Xóa',
    Login: 'Đăng nhập',
    Logout: 'Đăng xuất',
    ChangePassword: 'Đổi mật khẩu',
  },
  ScheduleType: {
    None: 'Không lặp lại',
    Daily: 'Hàng ngày',
    Weekly: 'Hàng tuần',
    Monthly: 'Hàng tháng',
    Yearly: 'Hàng năm',
  },
  ProxyStatus: {
    Available: 'Sẵn sàng sử dụng',
    InUse: 'Đang sử dụng',
    Unhealthy: 'Không sẵn sàng',
    Disabled: 'Tạm khóa'
  },
  UserRole: {
    Member: 'Tài khoản thường',
    Admin: 'Quản trị',
  },
  PocStatus: {
    Pending: 'Đang quét',
    Processing: 'Đang thực hiện',
    Completed: 'Hoàn thành',
    Error: 'Có lỗi'
  },
  LeakAccountPriority: {
    Normal: 'Tài khoản thường',
    Admin: 'Tài khoản admin'
  },
  CvePocType: {
    Execution: 'Thực thi mã từ xa',
    PathTraversal: 'Truy xuất file ngoài ý muốn',
    LoginBypass: 'Bypass đăng nhập',
    ArbitraryFileRead: 'Đọc file tùy ý',
  },
  ScheduleJobType: {
    ScanWide: 'Quét diện rộng',
    ScanDeep: 'Quét chuyên sâu',
    ReportEmail: 'Báo cáo định kỳ',
  },
  ScheduleJobTime: {
    None: '',
    Daily: 'Hàng ngày',
    Weekly: 'Hàng tuần',
    Monthly: 'Hàng tháng',
    Yearly: 'Hàng năm',
  },
  ScanSpeed: {
    Fast: 'Tốc độ nhanh',
    Medium: 'Tốc độ trung bình',
    Slow: 'Tốc độ chậm',
  },
  ScanAutoType: {
    Basic: 'Tự động cơ bản',
    Advance: 'Tự động nâng cao',
    Manual: 'Thủ công'
  },
  TaskScanStatus: {
    Pending: "Chờ quét",
    Processing: "Đang quét",
    Success: 'Thành công',
    Error: "Lỗi"
  }
};
